import { Paper, Typography } from '@mui/material';

const MetricCard = ({ title, value, subtitle, color = 'primary.main' }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      borderRadius: 0,
      border: '1px solid',
      borderColor: 'divider',
      minHeight: 140,
      background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(249,250,247,1) 100%)',
    }}
  >
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
      {title}
    </Typography>
    <Typography variant="h4" sx={{ fontWeight: 700, color, mb: 1 }}>
      {value}
    </Typography>
    {subtitle ? (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {subtitle}
      </Typography>
    ) : null}
  </Paper>
);

export default MetricCard;
